import { WidgetType } from '@enums/WidgetType'
import { UtmLeadProductType } from '@enums/UtmLeadProduct'
import {
  CHALLAN_WIDGET_LANDING,
  FASTAG_WIDGET_LANDING,
  HSRP_WIDGET_LANDING,
} from '@components/Product/ProductWidget/constants'
import {
  CHALLAN_WIDGET_SCANNER,
  PUC_ACKO_DRIVE_SCANNER,
  PUC_SEO_SCANNER,
  RTO_DETAIL_ACKO_DRIVE_SCANNER,
  RTO_DETAIL_SCANNER,
  RTO_VEHICLE_INFO_SCANNER,
} from './widgetImagesConstant'
import { CHALLAN_WIDGET_DESCRIPTION, PUC_WIDGET_DESCRIPTION, RTO_DETAIL_DESCRIPTION } from './commonConstants'

export const commonWidgetConfig = {
  default_deep_link: {
    [WidgetType.PUC_WIDGET]: 'https://ackoapp.onelink.me/TnnH/kolf7khp',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'https://ackoapp.onelink.me/TnnH/kolf7khp',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'https://ackoapp.onelink.me/TnnH/wbt2ms5q',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'https://ackoapp.onelink.me/TnnH/wbt2ms5q',
    [WidgetType.RTO_DETAIL_WIDGET]: 'https://ackoapp.onelink.me/TnnH/kolf7khp',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'https://ackoapp.onelink.me/TnnH/kolf7khp',
    [WidgetType.CHALLAN_WIDGET]: 'https://ackoctv.onelink.me/pNs0/xk00tycj',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 'https://ackoctv.onelink.me/pNs0/xk00tycj',
  },

  app_link: regNo => ({
    [WidgetType.PUC_WIDGET]: `acko.com://puc?reg_num=${regNo}`,
    [WidgetType.PUC_WIDGET_ACKODRIVE]: `acko.com://puc?reg_num=${regNo}`,
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: `acko.com://rto_details?reg_num=${regNo}`,
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: `acko.com://rto_details?reg_num=${regNo}`,
    [WidgetType.RTO_DETAIL_WIDGET]: `acko.com://rto_details?reg_num=${regNo}`,
    [WidgetType.RTO_DETAIL_ACKODRIVE]: `acko.com://rto_details?reg_num=${regNo}`,
    [WidgetType.CHALLAN_WIDGET]: `acko.com://pending_challan?reg_num=${regNo}`,
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: `acko.com://pending_challan?reg_num=${regNo}`,
  }),

  deep_link_value: {
    [WidgetType.PUC_WIDGET]: 'acko.com://puc_validity_lookup',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'acko.com://puc_validity_lookup',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'acko.com://rto_information',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'acko.com://rto_information',
    [WidgetType.RTO_DETAIL_WIDGET]: 'acko.com://rto_information',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'acko.com://rto_information',
    [WidgetType.CHALLAN_WIDGET]: 'acko.com://check_challan',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 'acko.com://check_challan',
    [WidgetType.CHALLAN_WIDGET_LANDING]: 'acko.com://pending_challan',
  },

  product: {
    [WidgetType.PUC_WIDGET]: 'SEO_PUC',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'SEO_PUC',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'SEO_vehicle_information',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'SEO_vehicle_information',
    [WidgetType.RTO_DETAIL_WIDGET]: 'SEO_RTO',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'SEO_RTO',
    [WidgetType.CHALLAN_WIDGET]: 'SEO_CHALLAN',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 'SEO_CHALLAN',
  },

  configName: {
    [WidgetType.PUC_WIDGET]: 'PUC_widget',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'PUC_widget',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'RTO_widget',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'RTO_widget',
    [WidgetType.RTO_DETAIL_WIDGET]: 'RTO_Detail_widget',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'RTO_Detail_widget',
    [WidgetType.CHALLAN_WIDGET]: 'challan_widget',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 'challan_widget',
  },
  scannerImg: {
    [WidgetType.PUC_WIDGET]: PUC_SEO_SCANNER,
    [WidgetType.PUC_WIDGET_ACKODRIVE]: PUC_ACKO_DRIVE_SCANNER,
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: RTO_VEHICLE_INFO_SCANNER,
    [WidgetType.RTO_DETAIL_WIDGET]: RTO_DETAIL_SCANNER,
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: RTO_VEHICLE_INFO_SCANNER,
    [WidgetType.RTO_DETAIL_ACKODRIVE]: RTO_DETAIL_ACKO_DRIVE_SCANNER,
    [WidgetType.CHALLAN_WIDGET]: CHALLAN_WIDGET_SCANNER,
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: CHALLAN_WIDGET_SCANNER,
  },
  widgetDescription: {
    [WidgetType.PUC_WIDGET]: PUC_WIDGET_DESCRIPTION,
    [WidgetType.PUC_WIDGET_ACKODRIVE]: PUC_WIDGET_DESCRIPTION,
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: RTO_DETAIL_DESCRIPTION,
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: RTO_DETAIL_DESCRIPTION,
    [WidgetType.RTO_DETAIL_WIDGET]: RTO_DETAIL_DESCRIPTION,
    [WidgetType.RTO_DETAIL_ACKODRIVE]: RTO_DETAIL_DESCRIPTION,
    [WidgetType.CHALLAN_WIDGET]: CHALLAN_WIDGET_DESCRIPTION,
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: CHALLAN_WIDGET_DESCRIPTION,
  },
  source: {
    [WidgetType.PUC_WIDGET]: 'SEO_PUC',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'SEO_PUC',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'SEO_VEHICLE_INFORMATION',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'SEO_VEHICLE_INFORMATION',
    [WidgetType.RTO_DETAIL_WIDGET]: 'SEO_VEHICLE_INFORMATION',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'SEO_VEHICLE_INFORMATION',
    [WidgetType.CHALLAN_WIDGET]: 'SEO_CHALLAN_PAGE',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 'SEO_CHALLAN_PAGE',
    [WidgetType.CHALLAN_WIDGET_LANDING]: 'SEO_CHALLAN_PAGE',
  },
  apiKey: {
    [WidgetType.PUC_WIDGET]: 'p1imWcCFBTEZ3Q',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'p1imWcCFBTEZ3Q',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'r7imWcSWATEZ2R',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'r7imWcSWATEZ2R',
    [WidgetType.RTO_DETAIL_WIDGET]: 'r7imWcSWATEZ2R',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'r7imWcSWATEZ2R',
    [WidgetType.CHALLAN_WIDGET]: 's7imWcVPATEZ5A',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 's7imWcVPATEZ5A',
    [WidgetType.CHALLAN_WIDGET_LANDING]: 's7imWcVPATEZ5A',
  },
  loginText: {
    [WidgetType.PUC_WIDGET]: 'GET PUC details',
    [WidgetType.PUC_WIDGET_ACKODRIVE]: 'GET PUC details',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET]: 'GET vehicle details',
    [WidgetType.RTO_VEHICLE_INFO_WIDGET_ACKODRIVE]: 'GET vehicle details',
    [WidgetType.RTO_DETAIL_WIDGET]: 'Get RTO details',
    [WidgetType.RTO_DETAIL_ACKODRIVE]: 'Get RTO details',
    [WidgetType.CHALLAN_WIDGET]: 'GET vehicle details',
    [WidgetType.CHALLAN_WIDGET_ACKODRIVE]: 'GET vehicle details',
    default: 'Get details',
  },
}

export const vehicleTypeConfig = {
  PRIVATE_CAR: 'Car',
  TWO_WHEELER: 'Bike',
  DEFAULT: 'N/A',
}

export const CAMPAIGN_NAME = {
  PMAX_CHALLAN: 'pmax-challan-may25',
  SEO_CHALLAN: 'seo-challan-jan25',
  SEM_CHALLAN: 'sem-challan-jan25',
  META_CHALLAN: 'meta-challan-jan25',
  SEO_FASTag: 'SEO_Fastag',
  SEM_FASTag: 'SEM_Fastag',
  WHATSAPP_WINBACK_CHALLAN: 'winback-challan-may25',
  BRANDFORMANCE_CHALLAN: 'brandformance-challan-may25',
  SEO_HSRP: 'seo-hsrp-may25',
  SEM_HSRP: 'sem-hsrp-may25',
}

export const CAMPAIGN_SOURCE = {
  PMAX_CHALLAN: 'PMAX_CHALLAN',
  SEO_CHALLAN: 'SEO_CHALLAN',
  SEM_CHALLAN: 'SEM_CHALLAN',
  META_CHALLAN: 'META_CHALLAN',
  SEO_FASTag: 'SEO',
  SEM_FASTag: 'SEM',
  WHATSAPP_CHALLAN: 'WHATSAPP',
  WHATSAPP_WINBACK_CHALLAN: 'WHATSAPP_WINBACK_CHALLAN',
  BRANDFORMANCE_CHALLAN: 'BRANDFORMANCE_CHALLAN',
  SEO_HSRP: 'SEO',
  SEM_HSRP: 'SEM',
}

export const campaignNameConfig = {
  [UtmLeadProductType.PMAX_CHALLAN]: CAMPAIGN_NAME.PMAX_CHALLAN,
  [UtmLeadProductType.SEM_CHALLAN]: CAMPAIGN_NAME.SEM_CHALLAN,
  [UtmLeadProductType.META_CHALLAN]: CAMPAIGN_NAME.META_CHALLAN,
  [UtmLeadProductType.SEO_CHALLAN]: CAMPAIGN_NAME.SEO_CHALLAN,
  [UtmLeadProductType.SEO_FASTAG]: CAMPAIGN_NAME.SEO_FASTag,
  [UtmLeadProductType.SEM_FASTAG]: CAMPAIGN_NAME.SEM_FASTag,
  [UtmLeadProductType.WHATSAPP_WINBACK_CHALLAN]: CAMPAIGN_NAME.WHATSAPP_WINBACK_CHALLAN,
  [UtmLeadProductType.BRANDFORMANCE_CHALLAN]: CAMPAIGN_NAME.BRANDFORMANCE_CHALLAN,
  [UtmLeadProductType.SEO_HSRP]: CAMPAIGN_NAME.SEM_HSRP,
  [UtmLeadProductType.SEM_HSRP]: CAMPAIGN_NAME.SEM_HSRP,
}

export const DEFAULT_CAMPAIGN_NAME = {
  [CHALLAN_WIDGET_LANDING]: CAMPAIGN_NAME.SEO_CHALLAN,
  [FASTAG_WIDGET_LANDING]: CAMPAIGN_NAME.SEO_FASTag,
  [HSRP_WIDGET_LANDING]: CAMPAIGN_NAME.SEO_HSRP,
}

export const sourceNameConfig = {
  [UtmLeadProductType.PMAX_CHALLAN]: CAMPAIGN_SOURCE.PMAX_CHALLAN,
  [UtmLeadProductType.SEM_CHALLAN]: CAMPAIGN_SOURCE.SEM_CHALLAN,
  [UtmLeadProductType.META_CHALLAN]: CAMPAIGN_SOURCE.META_CHALLAN,
  [UtmLeadProductType.SEO_CHALLAN]: CAMPAIGN_SOURCE.SEO_CHALLAN,
  [UtmLeadProductType.SEO_FASTAG]: CAMPAIGN_SOURCE.SEO_FASTag,
  [UtmLeadProductType.SEM_FASTAG]: CAMPAIGN_SOURCE.SEM_FASTag,
  [UtmLeadProductType.WHATSAPP_WINBACK_CHALLAN]: CAMPAIGN_SOURCE.WHATSAPP_WINBACK_CHALLAN,
  [UtmLeadProductType.BRANDFORMANCE_CHALLAN]: CAMPAIGN_SOURCE.BRANDFORMANCE_CHALLAN,
  [UtmLeadProductType.SEO_HSRP]: CAMPAIGN_SOURCE.SEO_HSRP,
  [UtmLeadProductType.SEM_HSRP]: CAMPAIGN_SOURCE.SEM_HSRP,
}

export const DEFAULT_SOURCE_NAME = {
  [CHALLAN_WIDGET_LANDING]: CAMPAIGN_SOURCE.SEO_CHALLAN,
  [FASTAG_WIDGET_LANDING]: CAMPAIGN_SOURCE.SEO_FASTag,
  [HSRP_WIDGET_LANDING]: CAMPAIGN_SOURCE.SEO_HSRP,
}

export const customIosStoreIdConfig = {
  [CHALLAN_WIDGET_LANDING]: '76dc0660-df4f-4af0-9c6b-0a55b3feb0e9',
  [FASTAG_WIDGET_LANDING]: '1c551935-72df-407d-922f-cd095ba3b12c',
  [HSRP_WIDGET_LANDING]: '41008fae-401c-418f-b11f-7b7e96dc122a',
  Default: '76dc0660-df4f-4af0-9c6b-0a55b3feb0e9',
}

export const customAndroidStoreIdConfig = {
  PMAX_CHALLAN: 'pmax-challan-may25',
  SEO_CHALLAN: 'seo-challan-jan25',
  SEM_CHALLAN: 'sem-challan-jan25',
  META_CHALLAN: 'meta-challan-jan25',
  SEO_FASTag: 'vas-fastag-may-25',
  SEM_FASTag: 'vas-fastag-may-25',
  WHATSAPP_WINBACK_CHALLAN: 'winback-challan-may25',
  BRANDFORMANCE_CHALLAN: 'brandformance-challan-may25',
  SEO_HSRP: 'wrapper_app_download_assets',
  SEM_HSRP: 'wrapper_app_download_assets',
}

export const DEFAULT_CUSTOM_ANDROID_STORE_ID = {
  [CHALLAN_WIDGET_LANDING]: customAndroidStoreIdConfig.SEO_CHALLAN,
  [FASTAG_WIDGET_LANDING]: customAndroidStoreIdConfig.SEO_FASTag,
  [HSRP_WIDGET_LANDING]: customAndroidStoreIdConfig.SEO_HSRP,
  Default: customAndroidStoreIdConfig.SEO_CHALLAN,
}
